import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { mercadoPagoService } from '../services/mercadoPagoService';

const PagamentoRetorno: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Capturar parâmetros da URL (Mercado Pago envia payment_id, collection_status, etc.)
    const status = searchParams.get('status');
    const paymentId = searchParams.get('payment_id');
    const preferenceId = searchParams.get('preference_id');
    const externalReference = searchParams.get('external_reference');
    const collectionStatus = searchParams.get('collection_status');

    console.log('Parâmetros recebidos:', {
      status,
      paymentId,
      preferenceId,
      externalReference,
      collectionStatus
    });

    const decideDestination = (finalStatus: string) => {
      const state = { paymentId, preferenceId, externalReference, status: finalStatus };
      if (finalStatus === 'approved') {
        navigate('/pagamento/sucesso', { state });
      } else if (finalStatus === 'rejected') {
        navigate('/pagamento/erro', { state });
      } else if (finalStatus === 'pending') {
        navigate('/pagamento/pendente', { state });
      } else {
        navigate('/pagamento/erro', { state: { ...state, status: 'unknown' } });
      }
    };

    // Priorizar collection_status quando disponível (padrão do Mercado Pago)
    const effectiveStatus = collectionStatus || status;

    if (effectiveStatus === 'approved' || effectiveStatus === 'rejected' || effectiveStatus === 'pending') {
      decideDestination(effectiveStatus);
      return;
    }

    // Se não temos status válido mas temos payment_id, consultar via API
    if (paymentId) {
      mercadoPagoService
        .getPaymentStatus(paymentId)
        .then((resp) => {
          const apiStatus = resp.status === 'approved' ? 'approved' : 
                           resp.status === 'rejected' ? 'rejected' : 'pending';
          decideDestination(apiStatus);
        })
        .catch(() => {
          decideDestination('unknown');
        });
      return;
    }

    // Fallback: redirecionar para erro
    decideDestination('unknown');
  }, [navigate, searchParams]);

  // Página de loading enquanto redireciona
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
          <Clock className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Processando Retorno do Pagamento
        </h2>
        <p className="text-gray-600">
          Aguarde enquanto redirecionamos você...
        </p>
      </div>
    </div>
  );
};

export default PagamentoRetorno;
